// @core/api/endpoints/workflow/generate_test_case.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GenerateTestCaseRequest,
  TestCaseResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Generate test case
 * Auto-generates a test case using NodeType sample data (happy path, error path, empty data) or by capturing a real execution.
 */
export async function GenerateTestCase(
  pipeline_id: string,
  data: GenerateTestCaseRequest,
  options?: RequestOptions
): Promise<TestCaseResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id/test-cases/generate`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.post<TestCaseResponse>(requestPath, data, requestOptions);
}
